import logoBase64 from './assets/logo_2x.png'
import { getTextFontFamily } from './getTextFontFamily'
import { isFirefoxDesktop } from './isMobile'
import { loadImage } from './loadImage'
import { retinafy } from './retinafy'

export async function drawShareMap(canvasEl: HTMLCanvasElement, text: string[]) {
  const fontFamily = getTextFontFamily()

  const width = canvasEl.width / 2
  const height = canvasEl.height / 2

  const canvas = document.createElement('canvas')
  const context = canvas.getContext('2d', isFirefoxDesktop() ? { willReadFrequently: true } : undefined)!
  retinafy(canvas, context, width, height + 22, true)

  // Background
  context.fillStyle = '#fff'
  context.fillRect(0, 0, width, height + 22)

  // Logo
  const logo = await loadImage(logoBase64)
  context.drawImage(logo, 2, 4, 49, 14)

  // Labels
  const label = text.map((t) => t.toUpperCase())
  let x = width
  const y = 11

  context.textBaseline = 'middle'
  context.textAlign = 'right'
  context.font = '9pt ' + fontFamily
  for (let i = label.length - 1; i >= 0; i--) {
    const text = label[i]
    let textWidth = context.measureText(text).width

    context.fillStyle = '#4c5261'
    context.fillText(text, x, y)

    if (i > 0) {
      const divider = '  •  '
      context.fillStyle = '#5faaf4'
      context.fillText(divider, x - textWidth, y)
      textWidth = textWidth + context.measureText(divider).width
    }

    x = x - textWidth
  }

  context.drawImage(canvasEl, 0, 0, canvasEl.width, canvasEl.height, 0, 22, width, height)
  return canvas.toDataURL()
}
